const uiGetters = {
  getToast: (state) => state.toast,
  getPending: (state) => state.pendingRequests > 0,
  isLoading: (state) => state.isLoading,
  getMenuVisible: (state) => state.menuVisible,
  getRegsiterError: (state) => state.registerError,
  getIsMaintenance: (state) => state.is_maintenance
}

export { uiGetters }
